import React from 'react'
import {Box, Flex, Image, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import arrowImage from '../../../../../../../assets/images/acquisition_decision_arrow.svg'

// Shown instead of Pending or Unsupported when a broker referred the business:
// the broker carries the outcome, so the business is told to expect their call
// rather than being given reasons or a next step of its own.
const BrokerReferred = () => {
  const {t} = useTranslation('onboarding')

  return (
    <Flex
      p={{base: 'sm', lg: 'lg'}}
      flexDirection="column"
      justify="space-between"
      height="100%"
    >
      <Flex flexDirection="column" gap="md">
        <Text textStyle="caption">
          {t('onboarding:AcquisitionDecisionBrokerReferred.subHeading')}
        </Text>
        <Text textStyle="headline2" fontSize={{base: '2xl', lg: '48px'}}>
          {t('onboarding:AcquisitionDecisionBrokerReferred.heading')}
        </Text>
      </Flex>

      <Flex borderBottom="1px" px="0" py="md" align="center">
        <Image
          src={arrowImage}
          width="32px"
          height="32px"
          mr="sm"
          display={{base: 'none', sm: 'block'}}
        />
        <Box
          as="span"
          flex="1"
          textAlign="left"
          textStyle="headline4"
          fontSize={{base: 'md', md: 'lg'}}
          textTransform="uppercase"
        >
          {t('onboarding:AcquisitionDecisionBrokerReferred.brokerNotified')}
        </Box>
      </Flex>
    </Flex>
  )
}

export default BrokerReferred
